import { SerializedError } from '@reduxjs/toolkit';
import { FetchBaseQueryError } from '@reduxjs/toolkit/dist/query';
import { toast } from 'react-toastify';

const messageBasedOnStatus = (error: any, action: string, customOptions?: ICustomToastOption) => {
  switch (error.status) {
    case 400:
    case 500:
      if (!customOptions) {
        if ('data' in error && 'message' in error.data) {
          toast(error.data.message, { type: 'error' });
        } else {
          const errorType = error.status === 400 ? 'Network' : 'Application';
          toast(`${errorType} Error: Failed ${action}`, { type: 'error' });
        }
      } else {
        const { error } = customOptions;
        toast(`${error?.title}: ${error?.description}`, { type: 'error' });
      }
      break;
    case 'FETCH_ERROR':
      toast(`Network Error: Failed ${action}`, { type: 'error' });
      break;
    default:
      toast(`Application Error: Failed ${action}`, { type: 'error' });
      break;
  }
};

interface MutationSuccess<Response> {
  data: Response;
}
interface ICustomToastAction {
  title: string;
  description: string;
}
interface ICustomToastOption {
  success?: ICustomToastAction;
  error?: ICustomToastAction;
}
export const checkForMutationSuccess = <T>(
  x: MutationSuccess<T> | { error: SerializedError | FetchBaseQueryError },
  action: string,
  customErrorMessage?: string,
  customOptions?: ICustomToastOption
): x is MutationSuccess<T> => {
  if ('error' in x) {
    const { error } = x;
    if (error) {
      if (customErrorMessage) {
        toast(customErrorMessage, { type: 'error' });
      }
      if (!customErrorMessage && 'status' in error) {
        messageBasedOnStatus(error, action, customOptions);
      }
    }
    return false;
  }
  if (!customOptions) {
    toast(`Finished ${action}`, { type: 'success' });
  } else {
    const { success } = customOptions;
    toast(`${success?.title}: ${success?.description}`, { type: 'success' });
  }
  return true;
};
